/** Nome visível. Não entra no i18n: nome próprio não se traduz. */
export const NOME_DO_JOGO = 'Ultima Idle';
